import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { applyExperienceFromLocation } from "../utils/experienceContext";

export function ExperienceTracker() {
  const location = useLocation();

  useEffect(() => {
    applyExperienceFromLocation(location.pathname, location.search);
  }, [location.pathname, location.search]);

  return null;
}
